import axios from "axios";
import * as actionType from "../../../constant/actionType";

const GenerateProviderOverviewReportFunction = (apiData) => async (dispatch) => {
 try {
  console.log("Working ??");
  const response = await axios({
   method: "post",
   headers: {
    Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
    "Content-Type": "application/json",
   },
   url: `${actionType.environment_url}/api/admin/GenerateProviderOverviewReportFunction`,
   data: {
    ...apiData,
    provider_org_ids: JSON.stringify(
      apiData.provider_org_ids?.map((item) => item?.provider_org_id)
    ),
    client_org_ids: JSON.stringify(apiData?.client_org_ids),
    provider_type_ids: JSON.stringify(apiData?.provider_type_ids),
   },
  });

  return response.data;
 } catch (error) {
  return error.message;
 }
};

export { GenerateProviderOverviewReportFunction };

